<template>
  <div>
    <VHeader/>
    <div class="success-body">
      <img src="../assets/success.png">
      <div>提交成功!</div>
    </div>

  </div>

</template>

<script>
  import VHeader from './VHeader'

  export default {
    name: 'success',
    data () {
      return {
      }
    },
    components: {
      VHeader
    },
  }
</script>

<style scoped>
.success-body {
  margin-top: 40px;
  text-align: center;
  padding: 20px;
  animation: fadeIn 0.5s ease-in-out;
}

.success-body img {
  width: 120px;
  height: 120px;
  margin-bottom: 16px;
  animation: scaleIn 0.6s cubic-bezier(0.18, 0.89, 0.32, 1.28);
}

.success-body div {
  color: #2283EB;
  font-size: 1.5em;
  font-weight: 500;
  background: linear-gradient(135deg, #2283EB, #1565C0);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes scaleIn {
  from {
    transform: scale(0.8);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}

@media screen and (max-width: 768px) {
  .success-body {
    margin-top: 30px;
  }
  .success-body img {
    width: 100px;
    height: 100px;
  }
  .success-body div {
    font-size: 1.3em;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/success.vue